import { SearchResultFacetItem } from './search-result-facet-item.model';
import { SearchFacetFilter } from './search-facet-filter.model';
import { SearchFacetRangeFilter } from './search-facet-range-filter.model';

export class SearchResultFacet {
  public items: SearchResultFacetItem[];

  constructor(public field: string, public label: string) {
    this.items = [];
  }

  public createQuery(
    q: string,
    facetFilters: SearchFacetFilter[],
    rangeQueries: SearchFacetRangeFilter[]
  ) {
    for (const item of this.items) {
      item.createQuery(q, facetFilters, rangeQueries);
    }
  }
}
